import { useState } from "react";
import { FaHandHoldingUsd, FaHandsHelping, FaFileAlt, FaMoneyCheckAlt, FaIdCard } from "react-icons/fa";

import { Card, Carousel, CarouselIndicators, Modal } from "../components/carousel";

import icon_1 from "../assets/icons/Adli_Tip_Teknolojileri.png";
import icon_2 from "../assets/icons/Afetlere_Hazirlik.png";
import icon_3 from "../assets/icons/Akilli_Sehir.jpg";
import icon_4 from "../assets/icons/Biyometrik_Sistemler.png";
import icon_5 from "../assets/icons/Butunlesik_Guvenlik_Sistemler.png";
import icon_6 from "../assets/icons/Deprem_Oncesi_Sonrasi.png";
import icon_7 from "../assets/icons/Gozetleme.jpg";
import icon_8 from "../assets/icons/Iletisim_Haberlesme.jpg";
import icon_9 from "../assets/icons/Trafik.png";


const Anasayfa = () => {
  const [selectedCard, setSelectedCard] = useState(null);

  const cardData = [
  {
    alt: "Biometric Systems",
    title: "Biometric Systems",
    src: icon_4,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Facial Recognition</li>
        <li class="list-group-item">Voice Recognition</li>
        <li class="list-group-item">Gesture Recognition</li>
        <li class="list-group-item">Fingerprint Recognition</li>
        <li class="list-group-item">Retina-Iris Recognition</li>
        <li class="list-group-item">Gait Recognition</li>
      </ul>
  },
  {
    alt: "Integrated Security Systems",
    title: "Integrated Security Systems",
    src: icon_5,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Cybersecurity</li>
        <li class="list-group-item">AI Applications</li>
        <li class="list-group-item">Border Security & Immigration Control
          <ul class="list-group list-group-flush list-card">
            <li class="list-group-item">Intrusion Detection</li>
            <li class="list-group-item">Access Control</li>
            <li class="list-group-item">Authentication</li>
          </ul>
        </li>
        <li class="list-group-item">AI & Machine Learning</li>
        <li class="list-group-item">Unwanted Substance Detection</li>
        <li class="list-group-item">Explosive Detection and Disposal</li>
        <li class="list-group-item">Advanced Sensors and Scanners</li>
        <li class="list-group-item">Blockchain-Based Systems and Cryptology</li>
      </ul>
  },
  {
    alt: "Smart City",
    title: "Smart City",
    src: icon_3,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">AI-powered Decision-Making Infrastructure</li>
        <li class="list-group-item">AI-assisted Urban Design</li>
        <li class="list-group-item">Big Data in Transportation and Security</li>
        <li class="list-group-item">Transportation Security</li>
        <li class="list-group-item">Critical Infrastructure Security</li>
        <li class="list-group-item">IoT Supported Network Connected Traffic Flow Management System
          <ul class="list-group list-group-flush list-card">
            <li class="list-group-item">Smart Transportation</li>
            <li class="list-group-item">Smart Lighting</li>
            <li class="list-group-item">Smart Traffic Lights</li>
            <li class="list-group-item">Smart Parking</li>
          </ul>
        </li>
        <li class="list-group-item">Cyber Intelligence and Threat Detection</li>
        <li class="list-group-item">Mobile Security Systems</li>
      </ul>
  },
  {
    alt: "Communication and Networking",
    title: "Communication and Networking",
    src: icon_8,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Secure Communication</li>
        <li class="list-group-item">Wireless Communication</li>
        <li class="list-group-item">Satellite Communication</li>
        <li class="list-group-item">Secure Cloud</li>
        <li class="list-group-item">Cloud-Based Data Security</li>
        <li class="list-group-item">IoT Security</li>
        <li class="list-group-item">Secure Infrastructure</li>
        <li class="list-group-item">Encryption</li>
        <li class="list-group-item">Contactless Access</li>
      </ul>
  },
  {
    alt: "Surveillance",
    title: "Surveillance",
    src: icon_7,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Mobile Surveillance</li>
        <li class="list-group-item">AI & Machine Learning</li>
        <li class="list-group-item">X-Ray Systems</li>
        <li class="list-group-item">Milimeter-Wave Systems</li>
        <li class="list-group-item">Video Surveillance</li>
      </ul>
  },
  {
    alt: "Forensic Technology",
    title: "Forensic Technology",
    src: icon_1,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Crime Scene Investigation</li>
        <li class="list-group-item">Forensic Toxicology and Poisoning</li>
        <li class="list-group-item">Traffic and Insurance Medicine</li>
        <li class="list-group-item">Identity Verification</li>
        <li class="list-group-item">Biological Material Identification</li>
        <li class="list-group-item">Clothing Analysis in Forensic Cases</li>
        <li class="list-group-item">Computer, Internet and Forensic Medicine</li>
        <li class="list-group-item">Narcotics</li>
      </ul>
  },
  {
    alt: "Traffic",
    title: "Traffic",
    src: icon_9,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Traffic Radars</li>
        <li class="list-group-item">Smart and Secure Transportation</li>
        <li class="list-group-item">Smart Traffic Lights</li>
        <li class="list-group-item">Advanced Sensors</li>
        <li class="list-group-item">License Plate and Vehicle Recognition</li>
      </ul>
  },
  {
    alt: "Disaster Preparedness, Response and Post-Disaster Aid Management",
    title: "Disaster Preparedness, Response and Post-Disaster Aid Management",
    src: icon_2,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Preventive Measures</li>
        <li class="list-group-item">Effective Monitoring Systems</li>
        <li class="list-group-item">UAV & Satellite Positioning Systems</li>
        <li class="list-group-item">Simulations</li>
        <li class="list-group-item">Physical Access Control Systems</li>
        <li class="list-group-item">Post-Disaster Planning</li>
      </ul>
  },
  {
    alt: "Earthquake Preparedness and Post-Earthquake Measures",
    title: "Earthquake Preparedness and Post-Earthquake Measures",
    src: icon_6,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Precision Mapping</li>
        <li class="list-group-item">Early Warning Systems</li>
        <li class="list-group-item">Person Location Tracking Technologies</li>
        <li class="list-group-item">Wall Penetration Imaging Technologies</li>
        <li class="list-group-item">IoT-assisted Post-Earthquake Aid Planning</li>
      </ul>
  }]

  return (
    <div className="mt-4 pt-4">
      
      <Carousel />

      <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Focus Technologies</h2>
          </div>
        </div>

        <div className="cards">
          {cardData.map((card, index) => (
            <Card
              key={index}
              alt={card.alt}
              src={card.src}
              title={card.title}
              onOpen={() => setSelectedCard(card)}
            />
          ))}
        </div>

        <Modal
          show={!!selectedCard}
          title={selectedCard?.title}
          description={selectedCard?.description}
          onClose={() => setSelectedCard(null)}
        />
      </section>
      
      {/* <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Haberler</h2>
          </div>
        </div>

        <CarouselIndicators />

      </section> */}

    </div>
  );
};

export default Anasayfa;
